import { render, staticRenderFns } from "./Tezspire.vue?vue&type=template&id=a9f0b2e8&scoped=true"
import script from "./Tezspire.vue?vue&type=script&lang=js"
export * from "./Tezspire.vue?vue&type=script&lang=js"
import style0 from "./Tezspire.vue?vue&type=style&index=0&id=a9f0b2e8&prod&lang=scss&scoped=true"
import style1 from "./Tezspire.vue?vue&type=style&index=1&id=a9f0b2e8&prod&lang=scss"
import style2 from "./Tezspire.vue?vue&type=style&index=2&id=a9f0b2e8&prod&lang=scss&scoped=true"
import style3 from "./Tezspire.vue?vue&type=style&index=3&id=a9f0b2e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f0b2e8",
  null
  
)

export default component.exports